module.exports = __webpack_public_path__ + "static/media/loc2_img2.877a2792.jpg";